export default __webpack_public_path__ + "static/signin-modal-horizontal-2d6b9d0ad748f719071b40f8f83b0e30.jpg";